<template>
  <div id="main">
    <div id="cabecera">
      <!--   <nav class="navbar navbar-expand-lg navbar-dark bg-dark static-top">
        <div class="container">
          <img class="logo" src="../assets/logo-servel.png" />
          <a class="navbar-brand" href="#">{{ name }}</a>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item active">
                <a class="nav-link" href="https://www.servel.cl/">
                  Servel
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://contacto.servel.cl"
                  >Contacto</a
                >
              </li>
              <li class="nav-item">
                <b-button variant="outline-danger" href="./logout"
                  >Cerrar sesión</b-button
                >
              </li>
            </ul>
          </div>
        </div>
      </nav> -->

      <b-navbar toggleable="lg" fiexd="top" type="dark" variant="dark">
        <img class="logo" src="../assets/logo-servel.png" />
        <a class="navbar-brand" href="#">{{ name }}</a>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item href="https://www.servel.cl/">Servel</b-nav-item>
            <b-nav-item href="https://contacto.servel.cl">Contacto</b-nav-item>
            <b-button variant="outline-danger" class="my-2 my-sm-0" href="./logout">Cerrar sesión</b-button>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
    <div id="formulario">
      <br />
      <p class="text-center">{{ mensaje }}</p>
      <transition name="fade">
        <div class="row justify-content-center" v-if="statusCode == 200">
          <div class="col-lg-8">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>DATOS ELECTORALES</strong>
                  </td>
                </tr>
                <tr>
                  <td>RUN</td>
                  <td>{{ datos.cedula }}-{{ datos.dv }}</td>
                </tr>
                <tr>
                  <td>Nombre</td>
                  <td>{{ datos.nombre }}</td>
                </tr>
                <tr>
                  <td>Correo Electrónico</td>
                  <td>{{ datos.email }} <a href="https://notificaciondigital.servel.cl/actualizar-correo" target="_blank" class="btn btn-outline-info btn-sm">Actualizar correo</a></td>
                </tr>
                <tr>
                  <td>Circunscripción Electoral</td>
                  <td>{{ datos.nombre_circuns }}</td>
                </tr>
                <tr>
                  <td>Dirección</td>
                  <td>
                    {{ datos.calle }} {{ datos.numero }} {{ datos.letra }}
                    <!-- {{ datos.resto }} <a href="https://cambiodomicilio.servel.cl/solicitar" target="_blank" class="btn btn-outline-info btn-sm">Solicitud de cambio de domicilio electoral</a> -->
                    {{ datos.resto }} 
                  </td>
                </tr>
                <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Comuna</td>
                  <td>{{ datos.nombre_comuna }}</td>
                </tr>
                <tr v-else>
                  <td>Ciudad</td>
                  <td>{{ datos.nombre_comuna }}</td>
                </tr>
                <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Provincia</td>
                  <td>{{ datos.nombre_provincia }}</td>
                </tr>
                <tr v-if="datos.codigo_pais == 'CL'">
                  <td>Región</td>
                  <td>{{ datos.nombre_region }}</td>
                </tr>
                <tr>
                  <td>País</td>
                  <td>{{ datos.glosa_pais }}</td>
                </tr>
<!--                 <tr>
                  <td>Pueblo indígena</td>
                  <td>{{ datos.nom_pueblo }}</td>
                </tr> -->
                <!--               <tr>
                  <td>Mesa</td>
                  <td>{{ datos.fusion }}{{ datos.tipomesa }}</td>
                </tr> -->
                <tr v-if="datos.estado_sufragio == 'SÍ'" class="table-success">
                  <td>Habilitado para sufragar</td>
                  <td>{{ datos.estado_sufragio }}</td>
                </tr>
                <tr v-else class="table-danger">
                  <td>Habilitado para sufragar</td>
                  <td>{{ datos.estado_sufragio }}</td>
                </tr>
              </tbody>
            </table>

            <div class="table-responsive" v-if="datos.estado_sufragio != 'SÍ'">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td colspan="2">
                      <strong>DETALLE INHABILIDAD</strong>
                    </td>
                  </tr>
                  <tr v-for="inhabilidad in inhabilidad">
                    <td>{{ inhabilidad.penal }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

<!--             <div class="table-responsive" v-if="vocal.length > 0">
              <table class="table table-striped">
                <tbody>
                  <tr>
                    <td colspan="5">
                      <strong>REGISTRO HISTORICO VOCAL DE MESA</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>FECHA ELECCIÓN</td>
                    <td>ELECCIÓN</td>
                    <td>CIRCUNSCRIPCIÓN ELECTORAL</td>
                    <td>MESA</td>
                    <td>ESTADO</td>
                  </tr>
                  <tr v-for="vocal in vocal">
                    <td>{{ vocal.fecha_eleccion }}</td>
                    <td>{{ vocal.eleccion }}</td>
                    <td>{{ vocal.nom_circuns }}</td>
                    <td>{{ vocal.nom_mesa }}</td>
                    <td>{{ vocal.estado }}</td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          </div>
        </div>
        <div class="row justify-content-center" v-else-if="statusCode == 201">
          <div class="alert alert-dark" role="alert">RUN no encontrado</div>
        </div>
      </transition>

      <div class="text-center" v-if="spiner == true && statusCode == ''">
        <b-spinner label="Spinning"></b-spinner>
        <b-spinner type="grow" label="Spinning"></b-spinner>
        <b-spinner variant="danger" label="Spinning"></b-spinner>
        <b-spinner type="grow" label="Spinning"></b-spinner>
        <b-spinner label="Spinning"></b-spinner>
      </div>
    </div>
    <footer class="py-5 bg-dark">
      <div class="container">
        <p class="m-0 text-center text-white">
          Servicio Electoral {{ version }}
        </p>
      </div>
      <!-- /.container -->
    </footer>
  </div>
</template>

<script>
import auth from "../app/auth";
import axios from "axios";
//import "../assets/estilo.css"
import router from "../router/index";

export default {
  name: "Home",
  data: function () {
    return {
      version: process.env.VUE_APP_VERSION,
      name: process.env.VUE_APP_NAME,
      api_url: process.env.VUE_APP_API_URL,
      api_url_2: process.env.VUE_APP_API_URL_2,
      api_url_3: process.env.VUE_APP_API_URL_3,
      datos: [],
      inhabilidad: [],
      vocal: [],
      spiner: false,
      mensaje: "",
      statusCode: "",
    };
  },
  mounted: function () {
    this.consultaDatos();
  },
  methods: {
    consultaDatos: function () {
      var token = auth.auth.signInUserSession.idToken.jwtToken;
      var configuracion = {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      this.spiner = true;
      axios
        .post(this.api_url, null, configuracion)
        .then(
          (response) => (
            (this.datos = response.data.datos),
            (this.statusCode = response.data.statusCode)
          )
        )
        .catch((error) => {
          this.mensaje = error;
          this.spiner = false;
          if ([401, 403].indexOf(error.request.status) !== -1) {
            console.log("The incoming token has expired");
            router.push({ path: "/logout" });
          }
        });

      axios
        .post(this.api_url_2, null, configuracion)
        .then((response) => (this.inhabilidad = response.data.datos))
        .catch((error) => {
          this.spiner = false;
          if ([401, 403].indexOf(error.request.status) !== -1) {
            console.log("The incoming token has expired");
            router.push({ path: "/logout" });
          }
        });

      /*         axios
        .post(this.api_url_3, null, configuracion)
        .then(
          (response) => (
            (this.vocal = response.data.datos)
          )
        )
        .catch((error) => {
          this.spiner = false;
          if ([401, 403].indexOf(error.request.status) !== -1) {
            console.log("The incoming token has expired");
            router.push({ path: "/logout" });
          }
        }); */
    },
  },
};
</script>

<style>
.body {
  margin-bottom: 100px;
}
</style>
